import { Component, computed, inject, input, output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { TranslocoPipe } from '@jsverse/transloco';
import { ENVIRONMENT } from '../../../../environments/environment.interface';
import { DashboardItem } from '../../../api/app-types/dashboard.app';
import { Paginator } from '../../../core/components/paginator/paginator';
import { PaginatedResponse } from '../../../shared/pagination/paginated-response';
import { ClientCard } from '../client-card/client-card';

@Component({
	selector: 'lvr-client-list',
	imports: [ClientCard, Paginator, TranslocoPipe],
	templateUrl: './client-list.html',
	styleUrl: './client-list.scss',
})
export class ClientList {
	private readonly env = inject(ENVIRONMENT);
	public readonly clients = input.required<DashboardItem[]>();
	public readonly clientsAreEmpty = computed(() => this.clients().length === 0);
	public readonly page = input<PaginatedResponse<DashboardItem> | undefined>();

	public readonly totalItems = computed(() => this.page()?.totalEntities ?? 0);
	public readonly pageIndex = computed(() => this.page()?.offset ?? 0);
	public readonly pageSize = computed(() => this.page()?.range ?? this.env.defaultPageSize);

	public readonly showFirstLastButtons = true;
	public readonly hidePageSize = false;

	public readonly pageRequested = output<{ pageIndex: number; pageSize: number }>();

	public handlePageEvent(event: PageEvent) {
		this.pageRequested.emit({ pageIndex: event.pageIndex, pageSize: event.pageSize });
	}
}
